import React from 'react';


const FirstStep = props => (
  <div>
    {props.coloresDePedidosList.filter(entry => props.pedidosConCheck.indexOf(entry.numPedidoVeh)>=0)
      .map((entry, key ) =>
    <div key={key}>
        <div className='pillSelct'>
          <ul className='pillSelct-pills'>
                <li className='pillSelct-pills-item pill pill-cyan' key={entry.numPedidoVeh} >{entry.numPedidoVeh}
                  <button className='pillSelct-delete' onClick={(event)=>props.clickQuitarPedido(event,entry.numPedidoVeh,entry.numPedidoVeh)} ><i className='icon ion-close pill-close' /></button>
                </li>

          </ul>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            {
              entry.orderColors.map((colorState, index)=>{

                return(<div className='form-group' key={index}>

                {props.codFamiliaVeh === "1"?(
                  <label className='labelInfo' disabled={props.codFamiliaVeh === "1"?true:false}>
                  <a   >
                    <i className='ion-minus-circled c-cyan mr-2' data-toggle='tooltip' data-placement='top' title='Borrar color' />Color
                  </a>
                  </label>
                ):(
                  <label className='labelInfo' disabled={props.codFamiliaVeh === "1"?true:false}>
                  <a   onClick={(event)=>props.clickQuitarColor(event,colorState.codColorFabricaVeh,entry.numPedidoVeh)} >
                    <i className='ion-minus-circled c-cyan mr-2' data-toggle='tooltip' data-placement='top' title='Borrar color' />Color
                  </a>
                  </label>
                )}


                  <div className='select'>
                    <select className='form-control' disabled={props.codFamiliaVeh === "1"?true:false}
                    value={props.traerColor(props.colores,colorState.codColorFabricaVeh)}
                    onChange={(event) =>props.changeOptionColor(event,colorState.codColorFabricaVeh,entry.numPedidoVeh,colorState.id)}
                    >
                          <option value='' >Color</option>
                      {
                        props.colores.map(color =>
                          <option key={color.codPintura} value={`${color.codPintura}-${color.color}-${color.colorSunarp}-${color.codColorSunarp}`}>{color.color}</option>
                        )
                      }
                    </select>
                    <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                  </div><span className='error'>mensaje de error</span>
                  <label className='formExtraInfo'><i className='ion-information-circled' />
                    Color SUNARP: {
                      props.colores.find(color => color.codPintura === colorState.codColorFabricaVeh) === undefined ?
                        '' : props.colores.find(color => color.codPintura === colorState.codColorFabricaVeh).colorSunarp
                    }
                  </label>
                </div>);
              })
            }
            <button disabled={props.codFamiliaVeh === "1"?true:false} className='btn btn-iconLeft btn-link pull-right' onClick={(event)=>props.clickAgregarColor(entry.numPedidoVeh)} ><i className='ion-plus' /><span>Agregar color</span></button>
          </div>
          <div className='col-md-6 col-xs-12'>
            <label className='labelInfo'>Uso</label>
            <div className='select'>
              <select className='form-control'
              value={props.traerUso(props.usos,entry.codAVtaFamUso)}
              onChange={(event) =>props.changeOptionUso(event,entry.numPedidoVeh)}
              >
                <option value='' >Uso</option>
                {
                  props.usos.map((uso,key)=>
                    <option key={key} value={`${uso.codAVtaFamUso}-${uso.desUsoVeh}`}>{uso.desUsoVeh}</option>
                  )
                }
              </select>
              <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
            </div><span className='error'>mensaje de error</span>
          </div>
        </div>
        <div className='row' style={{display:entry.status===0?'block':'none'}}  >
          <div className='col-md-12'>
          <span>(*) El uso y los colores provienen de proforma</span>
          </div>
        </div>
    </div>
    )}

    <div className='modal-actions'>
      <button className='btn btn-default' onClick={() => props.closeModal()}>Volver</button>
      <button className='btn btn-primary pull-right' onClick={() => props.fnSavePedidosColorUso()} >Aplicar</button>
    </div>
  </div>
);

export default FirstStep;



// WEBPACK FOOTER //
// ./src/pages/modals/AplicarColorUso/FirstStep.js